import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import { useSelectedCompany } from '../use-selected-company.hook';

/**
 * The Organisation filter options. They come from their own route because organisation is derived
 * from the email domain across every candidate, not just the page currently on screen.
 */
export const useShareCandidateOrganisations = (
  id: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
) => {
  const { selectedCompany } = useSelectedCompany();
  const companyId = selectedCompany?.id ?? '';

  const { data: organisations = [], isLoading } = useAppQuery({
    enabled: enabled && Boolean(companyId && id),
    queryFn: () =>
      ApiService.get<string[]>({
        endpoint: BackendRoute.DATA_ROOMS,
        routePath: [id ?? '', 'share-candidates', 'organisations'],
      }),
    queryKey: [QueryKey.DATA_ROOM_SHARE_CANDIDATE_ORGANISATIONS, companyId, id],
  });

  return { isLoading, organisations };
};
